import script from "./OccupancyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupancyPage.vue?vue&type=script&setup=true&lang=js"

import "./OccupancyPage.vue?vue&type=style&index=0&id=a9ad0c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9ad0c68"]])

export default __exports__